import PropTypes from "prop-types";
import { Button } from "@mui/material";

const PrimaryButton = ({
  children,
  type = "button",
  variant = "contained",
  color = "primary",
  disabled = false,
  onClick = () => {},
  ...rest
}) => {
  return (
    <Button
      type={type}
      variant={variant}
      color={color}
      disabled={disabled}
      onClick={onClick}
      sx={{
        width: "100%",
        fontSize: "18px",
        fontFamily: "var(--bold)",
        textTransform: "none",
        // Si el botón es de tipo "submit" y no está deshabilitado, cambia el color y bloquea los clicks.
        "&:disabled": {
          backgroundColor: "grey",
          cursor: "not-allowed",
        },
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(["contained", "outlined", "text"]),
  color: PropTypes.oneOf(["primary", "secondary", "inherit", "default"]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default PrimaryButton;
